import { StackIcon, CodeIcon } from "@radix-ui/react-icons";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  MenuContent,
  MenuRadioGroup,
  MenuRadioItem,
  MenuTrigger,
} from "@/components/ui/menu";
import { SimpleTooltip } from "@/components/ui/tooltip";

export function EditorSelector({
  editor,
  setEditor,
}: {
  editor: "canvas" | "json";
  setEditor: (editor: "canvas" | "json") => void;
}) {
  return (
    <DropdownMenu>
      <SimpleTooltip message="Editor type" asChild>
        <MenuTrigger asChild>
          <Button variant="ghost" size="smIcon">
            <div className="sr-only">Editor type: {editor}</div>
            {editor === "canvas" ? <StackIcon /> : <CodeIcon />}
          </Button>
        </MenuTrigger>
      </SimpleTooltip>
      <MenuContent side="right" sideOffset={16} align="start">
        <MenuRadioGroup
          value={editor}
          onValueChange={(value) => setEditor(value as "canvas" | "json")}
        >
          <MenuRadioItem value="canvas" defaultChecked>
            Canvas
          </MenuRadioItem>
          <MenuRadioItem value="json">JSON</MenuRadioItem>
        </MenuRadioGroup>
      </MenuContent>
    </DropdownMenu>
  );
}
